import styles from './medlemskapType.module.scss';
import { Link } from 'react-router-dom';
import Price from './Price';

function MedlemskapLink(props: {
    medlemskapstypeId: string;
    medlemskapstypePrice: number;
    routeToPersonalia: string;
    title: string;
    description: string;
}) {
    return (
        <Link to={props.routeToPersonalia} className={`${styles.typeContainer} ${styles.typeLink}`}>
            <h2 className={styles.name}>{props.title}</h2>
            <p className={styles.description}>{props.description}</p>
            <div className={styles.priceLineLinkSinglePrice}>
                <div key={props.medlemskapstypeId}>
                    <Price price={props.medlemskapstypePrice}></Price>
                </div>
                <div className={styles.choose}>Velg medlemskap</div>
            </div>
        </Link>
    );
}

export default MedlemskapLink;
